import { render, staticRenderFns } from "./BlotterComponentList.vue?vue&type=template&id=312994eb&scoped=true"
import script from "./BlotterComponentList.vue?vue&type=script&lang=js"
export * from "./BlotterComponentList.vue?vue&type=script&lang=js"
import style0 from "./BlotterComponentList.vue?vue&type=style&index=0&id=312994eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312994eb",
  null
  
)

export default component.exports